<template lang="html">
  <div>
      <!-- Main flex -->
    <main class="grid grid-cols-2 lg:grid-cols-5 mt-6 gap-4 px-4">
      <!-- Viewport -->
      <div class="lg:col-span-2 col-span-5 lg:order-1">
        <presenter-viewport ref="editorViewport" @create-take-folder="$refs.videoTakeList.showCreateFolderModal = true"
                            :room-key="roomKey"
                            :is-in-editor="true"
                            :presentation-id="presentationId"
                            v-bind:slides.sync="slides"
                            v-bind:current-slide-index.sync="currentSlideIndex"
                            :isLowDataModeOn="false" :room-activated="true"></presenter-viewport>
      </div>
      <!-- Media -->
      <div class="col-span-5 lg:col-span-3 order-2 lg:order-2 flex flex-col space-y-4 h-64 xl:h-96">
        <media-manager :is-host="true" :is-in-editor="true"></media-manager>
      </div>
      <div class="col-span-5 order-3">
        <div class="flex text-base justify-between">
          <div class="flex space-x-2">
            <h2 class="text-lg font-medium">
              Guided presentation editor
            </h2>
            <div>
              <span v-if="!isSaving" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                Saved
              </span>
              <span v-if="isSaving" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
                Saving...
              </span>
            </div>
          </div>
          <div>
            <button class="btn btn-destroy-secondary w-64" :draggable="true" @dragover="handleDragOver" @drop="deleteSlide">Trash</button>
            <button class="btn btn-secondary" @click="saveSlides" v-if="isSaving">Save presentation</button>
          </div>
        </div>
        <div class="w-full grid grid-cols-5 md:grid-cols-10 gap-2">
          <div v-for="(ss, i) in slideSlots" class="col-span-1" :key="i+'ss'">
            <div class="w-full text-gray-700 text-sm">{{i+1}}</div>
            <div v-if="typeof ss === 'undefined'" :draggable="true"
            @drop="onDrop($event, i)" class="flex justify-center items-center h-20 p-2 bg-gray-50 dark:bg-gray-800 rounded-lg shadow-inner text-sm text-gray-600 dark:text-gray-300"
            @dragover="handleDragOver($event)"
            >
	    <div>
              Drag and drop
	    </div>
            </div>
            <div :draggable="true" @drop="onDrop($event, i)" @dragover="handleDragOver($event)" @dragstart="handleSlideDragStart($event, ss, i)" @click="onSlideClick(i)" v-else-if="ss.media_type === 'audio'" class="bg-gray-900 slide-in-item col-span-1 h-24 rounded-lg shadow divide-y divide-gray-200 overflow-hidden">
              <div class="relative px-2 py-2 h-full">
                <div class="absolute bg-black text-white inset-x-0 py-1 text-xs z-10 bottom-0 px-4">
                  {{ ss.name }}
                </div>
                <!-- Audio icon -->
                <svg xmlns="http://www.w3.org/2000/svg" class="absolute text-white h-5 w-5 top-2 left-2" viewBox="0 0 20 20" fill="currentColor">
                  <path d="M18 3a1 1 0 00-1.196-.98l-10 2A1 1 0 006 5v9.114A4.369 4.369 0 005 14c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V7.82l8-1.6v5.894A4.37 4.37 0 0015 12c-1.657 0-3 .895-3 2s1.343 2 3 2 3-.895 3-2V3z" />
                </svg>
              </div>
            </div>
            <!-- Video thumbnail -->
            <div :draggable="true" @drop="onDrop($event, i)" @dragover="handleDragOver($event)" @dragstart="handleSlideDragStart($event, ss, i)" @click="onSlideClick(i)" v-else-if="ss.media_type === 'video'" class="bg-gray-900 slide-in-item col-span-1 h-24 rounded-lg shadow divide-y divide-gray-200 overflow-hidden">
              <div class="relative px-2 py-2 h-full">
              <div class="absolute bg-black text-white inset-x-0 py-1 text-xs z-10 bottom-0 px-4">
                {{  ss.name }}
              </div>
              <img :src="ss.thumbnail" class="absolute inset-0 z-1 object-cover w-full h-full transform"> 
              <!-- Film icon -->
              <svg xmlns="http://www.w3.org/2000/svg" class="absolute text-white h-5 w-5 z-20 top-2 left-2" viewBox="0 0 20 20" fill="currentColor">
                <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
              </svg>
            </div>
            </div>
            <div :draggable="true" @drop="onDrop($event, i)" @dragover="handleDragOver($event)" @dragstart="handleSlideDragStart($event, ss, i)" @click="onSlideClick(i)" v-else-if="ss.media_type === 'image'" class="relative bg-gray-900 slide-in-item col-span-1 h-24 rounded-lg shadow divide-y divide-gray-200 overflow-hidden">
            <div class="relative px-2 py-2 h-full" draggable="true">
              <img :src="ss.url" class="absolute inset-0 z-1 object-cover w-full h-full transform"> 
                <!-- Image icon -->
                <svg xmlns="http://www.w3.org/2000/svg" class="absolute text-white h-5 w-5 top-2 left-2" viewBox="0 0 20 20" fill="currentColor">
                  <path fill-rule="evenodd" d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z" clip-rule="evenodd" />
                </svg>

                <div class="absolute bg-black text-white inset-x-0 py-1 text-xs z-10 bottom-0 px-4">
                  {{ ss.name }}
                </div>
            </div>
            </div>
          </div>
        </div>

      </div>
    </main> <!-- MainFlex END -->
  </div>
</template>

<script>
import axios from 'axios';
import { localNotify } from 'utils/notifications';
export default {
  name: 'presentation-editor',
  props:{
    presentationId: {
      type: Number,
      required: true,
    }
  },
  data(){
    return {
      currentSlideIndex: 0,
      roomKey: "",
      //slides: [],
      slideSlots: new Array(20),
      isSaving: false,
      token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),

    }
  },
  methods: {
    onDrop(event, slideInd){
      const draggingType = event.dataTransfer.getData('type');
      // Media
      if(draggingType === "MEDIA"){
        let media = JSON.parse(event.dataTransfer.getData('media'));
        media.order = slideInd;
        media.media_id = media.id
        this.slideSlots.splice(slideInd, 1, media);
      }else if(draggingType == "SLIDE") { // another slide
        let media = JSON.parse(event.dataTransfer.getData('media'));
        let si = parseInt(event.dataTransfer.getData('sourceindex'));
        media.posInEditor = slideInd;
        let x = 0;
        if(si < slideInd){
          for(let i = si; i < slideInd; i++){
            this.slideSlots[i] = this.slideSlots[i+1];
            if(typeof this.slideSlots[i] !== 'undefined'){
              this.slideSlots[i].order -= 1;
              this.slideSlots[i].posInEditor -=1;
              x++;
            }
          }
          media.order = media.order + x;
          this.slideSlots.splice(slideInd, 1, media);
        }else if(si > slideInd){
          for(let i = si; i > slideInd; i--){
            this.slideSlots[i] = this.slideSlots[i-1];
            if(typeof this.slideSlots[i] !== 'undefined'){
              this.slideSlots[i].order += 1;
              this.slideSlots[i].posInEditor +=1;
              x++;
            }
          }
          media.order = media.order - x;
          this.slideSlots.splice(slideInd, 1, media);
        }

        //this.slideSlots.splice(si, 1, this.slideSlots[si]);
      }
      this.saveSlides();
    },
    handleDragOver(event){
      event.preventDefault();
    },
    onSlideClick(index){ // Navigate
      let newIndex = 0;
      for(let i = 0; i < this.slides.length; i++){
        if(this.slides[i].posInEditor === index){
          newIndex = this.slides[i].order;
        }
      }
      this.currentSlideIndex = newIndex;
    },
    handleSlideDragStart(event, media, index){
      event.dataTransfer.dropEffect = 'move';
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('type', 'SLIDE');
      event.dataTransfer.setData('sourceindex', index)
      event.dataTransfer.setData('media', JSON.stringify(media));
    },
    loadSlides(){
      let url = '/presentation/' + this.presentationId + '/slides';
      axios.get(url).then(response => {
        response.data.forEach(x => {
          let slide = {};
          slide.media_id = x.medium.id;
          slide.media_type = x.medium.media_type;
          slide.order = x.order;
          slide.posInEditor = x.order;
          slide.url = x.medium.url;
          slide.thumbnail = x.medium.thumbnail;
          slide.name = x.name;
          this.slideSlots.splice(x.order, 1, slide);
        });
      }).catch(response => {});
    },
    saveSlides(){
      if(this.slides.length <= 0) return;
      this.isSaving = true;
      let url = '/presentation/' + this.presentationId + '/slides';
      let slidesAsParams = this.slides.map(x => {
        return {
          order: x.posInEditor,
          media_id: x.media_id,
          name: x.name
        }
      })
      axios.post(url, {slides:slidesAsParams}, {
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': this.token
        }
      }).then(response => {
        this.isSaving = false;
      }).catch(response => {
        this.isSaving = false;
        localNotify('There was an error saving your presentation', 'error');
      });
    },
    deleteSlide(event, i){
      const draggingType = event.dataTransfer.getData('type');
      if(draggingType == "SLIDE") {
        let media = JSON.parse(event.dataTransfer.getData('media'));
        let si = parseInt(event.dataTransfer.getData('sourceindex'));
        this.slideSlots.splice(si, 1, undefined);
        this.saveSlides();
      }
    }
  },
  computed: {
    slides(){
      let slidesArray = [];
      let count = 0;
      this.slideSlots.forEach((x, i) => {
        if(typeof x === 'undefined') {
          return;
        }
        x.order = count;
        x.posInEditor = i;
        count += 1;
        slidesArray.push(x);
      });
      return slidesArray;
    }
  },
  mounted(){
    this.loadSlides();
  },
  watch: {
    slideSlots: function(){
      if(this.slideSlots.length - 1 == this.slides.length){
        for(let i = 0; i < 10; i++){
          this.slideSlots.push(undefined);
        }
      }
    }
  }
}
</script>
